import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;



export function getHeader(token) {
  return {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*", // Required for CORS support to work
    Authorization: token,
  };
}




export const getAvailableDocksApi = async (token) => {
  try {
    const response = await axios.get(apiUrl + `dock/web/dockmaster`, {
      headers: getHeader(token)
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getCountApi = async (token) => {
  try {
    const response = await axios.get(apiUrl + `dock/web/count`, {
      headers: getHeader(token)
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getHistoryCountApi = async (date,token) => {
  try {
    const response = await axios
      .post(apiUrl + `dock/web/history_count`, {"start_date":date}, { headers: getHeader(token) })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getLocationFreeDocksApi = async (token) => {
  try {
    const response = await axios.get(apiUrl + `dock/web/freedocks?search=`, {
      headers: getHeader(token)
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getLiveMonitorApi = async (token) => {
  try {
    const response = await axios.get(apiUrl + `dock/web/livemonitor`, {
      headers: getHeader(token)
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getTimingListApi = async (token) => {
  try {
    const response = await axios.get(apiUrl + `dock/web/timings`, {
      headers: getHeader(token)
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const locationBasedDockOutDockInApi = async (month,token) => {
  try {
    const response = await axios.post(apiUrl + `dock/web/location_in_out?period=${month}&search=`, {}, { headers: getHeader(token) });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};




export const getAverageDurationApi = async (data,token) => {
  try {
    const response = await axios
      .post(apiUrl + "dock/web/avarageduration", data, { headers: getHeader(token) })
      .then((res) => res)
      .catch((error) => {
        console.log("Error in getAverageDurationApi:", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Unexpected error in getAverageDurationApi:", err);
  }
};

export const fetchDaywiseInData = async (month,token) => {
  try {
    const response = await axios.post(`${apiUrl}dock/web/daywisein`, { period: month }, { headers: getHeader(token) });
    return response;
  } catch (error) {
    console.error("Daywise API error:", error);
    return { success: false, error: error.message || "Something went wrong" };
  }
};

export const getDaywiseAverageData = async (params,token) => {
  try {
    const response = await axios.post(`${apiUrl}dock/web/dailyavarage`, params, { headers: getHeader(token) });
    return response?.data?.daily_average || [];
  } catch (error) {
    console.error("Daywise Average API error:", error);
    return [];
  }
};

export const getLocationListApi = async (token) => {
  try {
    const response = await axios.get(`${apiUrl}get_location`, {
      headers: getHeader(token)
    });
    return response.data?.suggestionlist || [];
  } catch (err) {
    console.error("Error fetching locations:", err);
    return [];
  }
};

export const getDepartmentWiseData = async (params,token) => {
  try {
    const response = await axios.post(`${apiUrl}dock/web/departmentstatistics`, params, { headers: getHeader(token) });
    return response?.data?.data || [];
  } catch (error) {
    console.error("Daywise Average API error:", error);
    return [];
  }
};

export const getDepartmentWiseDockData = async (params, token) => {
  try {
    const response = await axios.post(`${apiUrl}dock/web/dock_log`, params, { headers: getHeader(token) });
    return response?.data?.data || [];
  } catch (error) {
    console.error("Daywise Average API error:", error);
    return [];
  }
};

export const getVehicleWiseData = async (params,token) => {
  try {
    const response = await axios.post(`${apiUrl}dock/web/vehiclelog`, params, { headers: getHeader(token) });
    return response?.data?.data || [];
  } catch (error) {
    console.error("Daywise Average API error:", error);
    return [];
  }
};